// extracted by mini-css-extract-plugin
export default {"container":"vision_container__DvV-6","right":"vision_right__5v5uX","left":"vision_left__ZRhJP"};